module.exports = __webpack_public_path__ + "static/media/energetic_slightly-happy.a149a2d5.svg";